import 'css-chunksrc/client/scenes/startDiscussion/styles.scss';export default {
  "form": "_form_13ftv_1",
  "group": "_group_13ftv_5",
  "title": "_title_13ftv_9",
  "folderSelection": "_folderSelection_13ftv_15",
  "textArea": "_textArea_13ftv_19",
  "text": "_text_13ftv_19",
  "name": "_name_13ftv_28",
  "main": "_main_13ftv_34",
  "buttons": "_buttons_13ftv_41"
};